module.exports = __webpack_public_path__ + "img/cz.8275d81c.svg";